import React from 'react';
import { useNova } from '../NovaContext';
import { NOVA_IDS } from '../constants';

export default function TabPanel({ id, scrollRef, onScroll, overlay, children }) {
    const { state } = useNova();

    return (
        <div
            role="tabpanel"
            id={NOVA_IDS.tabpanel(id)}
            aria-labelledby={NOVA_IDS.tab(id)}
            hidden={state.activeTab !== id}
            className="nova_tabpanel"
        >
            <div ref={scrollRef} onScroll={onScroll} tabIndex={0} className="nova_scroll">
                {children}
            </div>
            {overlay}
        </div>
    );
}
